import { useEffect } from "react";

/**
 * Keeps list pagination/filter state reflected in the URL for sharing and back navigation.
 */
export const useSyncListPaginationToUrl = ({
  pagination,
  buildSearchFromPagination,
  navigate,
  location,
}) => {
  useEffect(() => {
    const nextSearch = buildSearchFromPagination(pagination, location.search);
    const currentSearch = location.search || "";

    if (nextSearch !== currentSearch) {
      navigate(
        { pathname: location.pathname, search: nextSearch },
        { replace: true, state: location.state }
      );
    }
  }, [
    pagination,
    location.pathname,
    location.search,
    location.state,
    navigate,
    buildSearchFromPagination,
  ]);
};
